export default __webpack_public_path__ + "static/hialexacase1-d074e2dc80f5262650b9421c2a2d74b2.png";